import Storage from './storage';

export function setSessionStorage(session) {
  try {
    const { merchant, user, auth } = session;
    Storage.setLocalStorage('merchant', merchant);
    Storage.setLocalStorage('user', user);
    Storage.setLocalStorage('auth', auth);
    return true;
  } catch (err) {
    return err;
  }
}

export function getSessionStorage() {
  try {
    return {
      merchant: Storage.getLocalStorageMerchant(),
      user: Storage.getLocalStorage('user'),
      auth: Storage.getLocalStorage('auth'),
    };
  } catch (err) {
    return err;
  }
}

export function clearSessionStorage() {
  try {
    Storage.removeLocalStorage('merchant');
    Storage.removeLocalStorage('user');
    Storage.removeLocalStorage('auth');
    return true;
  } catch (err) {
    return err;
  }
}

export function setExportProducts(categories) {
  try {
    Storage.setLocalStorage('exportProducts', categories);
    Storage.setLocalStorage('canExport', false);
    return true;
  } catch (err) {
    return err;
  }
}

export function setCanExportProducts() {
  try {
    Storage.setLocalStorage('canExport', true);
    return true;
  } catch (err) {
    return err;
  }
}

export function getExportProducts() {
  try {
    return {
      categories: Storage.getLocalStorage('exportProducts'),
      canExport: Storage.getLocalStorage('canExport'),
    };
  } catch (err) {
    return err;
  }
}

export function clearExportProducts() {
  try {
    Storage.removeLocalStorage('exportProducts');
    Storage.removeLocalStorage('canExport');
    return true;
  } catch (err) {
    return err;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/session.js